/**
 * Favorite Team Service
 * Simple service to manage user's favorite team using the existing UserSettingsService
 */

import UserSettingsService from './userSettingsService';

class FavoriteTeamService {
  
  /**
   * Get all available teams from various sports
   * @returns {Array} Array of team objects with { name, sport, sportTitle }
   */
  static getAllAvailableTeams() {
    // This provides a comprehensive list of teams across major sports
    // Based on the teams appearing in your mock data and common professional teams
    const teams = [
      // NFL Teams (32 teams)
      { name: 'Kansas City Chiefs', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Buffalo Bills', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Green Bay Packers', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Dallas Cowboys', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'New England Patriots', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Pittsburgh Steelers', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'San Francisco 49ers', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Philadelphia Eagles', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Seattle Seahawks', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Denver Broncos', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Miami Dolphins', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Los Angeles Rams', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Baltimore Ravens', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Minnesota Vikings', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Las Vegas Raiders', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      { name: 'Tampa Bay Buccaneers', sport: 'americanfootball_nfl', sportTitle: 'NFL' },
      
      // NBA Teams (30 teams)
      { name: 'Los Angeles Lakers', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Boston Celtics', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Golden State Warriors', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Miami Heat', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Chicago Bulls', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'New York Knicks', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Brooklyn Nets', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Milwaukee Bucks', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Phoenix Suns', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Denver Nuggets', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Dallas Mavericks', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Philadelphia 76ers', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Los Angeles Clippers', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Toronto Raptors', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Atlanta Hawks', sport: 'basketball_nba', sportTitle: 'NBA' },
      { name: 'Sacramento Kings', sport: 'basketball_nba', sportTitle: 'NBA' },
      
      // MLB Teams (30 teams)
      { name: 'New York Yankees', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Los Angeles Dodgers', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Houston Astros', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Atlanta Braves', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Boston Red Sox', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'San Francisco Giants', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Chicago Cubs', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Philadelphia Phillies', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'New York Mets', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'San Diego Padres', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Tampa Bay Rays', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Toronto Blue Jays', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Chicago White Sox', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'St. Louis Cardinals', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Milwaukee Brewers', sport: 'baseball_mlb', sportTitle: 'MLB' },
      { name: 'Texas Rangers', sport: 'baseball_mlb', sportTitle: 'MLB' },
      
      // NHL Teams (32 teams)
      { name: 'Pittsburgh Penguins', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Boston Bruins', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Tampa Bay Lightning', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Colorado Avalanche', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Toronto Maple Leafs', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'New York Rangers', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Vegas Golden Knights', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Edmonton Oilers', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Florida Panthers', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Dallas Stars', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Carolina Hurricanes', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'New Jersey Devils', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Seattle Kraken', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Los Angeles Kings', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'New York Islanders', sport: 'icehockey_nhl', sportTitle: 'NHL' },
      { name: 'Washington Capitals', sport: 'icehockey_nhl', sportTitle: 'NHL' },
    ];

    // Sort teams by sport, then by team name
    return teams.sort((a, b) => {
      if (a.sport !== b.sport) {
        return a.sport.localeCompare(b.sport);
      }
      return a.name.localeCompare(b.name);
    });
  }

  /**
   * Get user's current favorite teams (all sports)
   * @returns {Promise<Object>} Object with sport keys and team names
   */
  static async getFavoriteTeams() {
    try {
      const favoriteTeams = await UserSettingsService.getSetting('favoriteTeams', []);
      
      // Convert array format to object format for backward compatibility
      if (Array.isArray(favoriteTeams)) {
        // If it's an array with one item, treat as legacy single favorite
        if (favoriteTeams.length === 1) {
          // Try to determine sport from team name for migration
          const teamName = favoriteTeams[0];
          const allTeams = this.getAllAvailableTeams();
          const teamObj = allTeams.find(t => t.name === teamName);
          if (teamObj) {
            return { [teamObj.sportTitle]: teamName };
          }
        }
        return {};
      }
      
      return favoriteTeams || {};
    } catch (error) {
      console.error('Error getting favorite teams:', error);
      return {};
    }
  }

  /**
   * Get user's favorite team for a specific sport
   * @param {string} sport - Sport title (NFL, NBA, MLB, NHL)
   * @returns {Promise<string|null>} Favorite team name or null if not set
   */
  static async getFavoriteTeamForSport(sport) {
    try {
      const favoriteTeams = await this.getFavoriteTeams();
      return favoriteTeams[sport] || null;
    } catch (error) {
      console.error('Error getting favorite team for sport:', error);
      return null;
    }
  }

  /**
   * Set user's favorite team for a specific sport
   * @param {string} sport - Sport title (NFL, NBA, MLB, NHL)
   * @param {string} teamName - Name of the team to set as favorite (null to clear)
   * @returns {Promise<boolean>} Success status
   */
  static async setFavoriteTeamForSport(sport, teamName) {
    try {
      const currentFavorites = await this.getFavoriteTeams();
      
      if (!teamName) {
        // Remove favorite for this sport
        delete currentFavorites[sport];
      } else {
        // Set favorite for this sport
        currentFavorites[sport] = teamName;
      }

      return await UserSettingsService.setSetting('favoriteTeams', currentFavorites);
    } catch (error) {
      console.error('Error setting favorite team for sport:', error);
      return false;
    }
  }

  /**
   * Check if a team is the user's favorite for its sport
   * @param {string} teamName - Name of the team to check
   * @param {string} sport - Sport title
   * @returns {Promise<boolean>} True if team is favorite for its sport
   */
  static async isFavoriteTeam(teamName, sport) {
    try {
      const favoriteTeam = await this.getFavoriteTeamForSport(sport);
      return favoriteTeam === teamName;
    } catch (error) {
      console.error('Error checking if team is favorite:', error);
      return false;
    }
  }

  /**
   * Get teams grouped by sport
   * @returns {Object} Teams grouped by sport key
   */
  static getTeamsGroupedBySport() {
    const teams = this.getAllAvailableTeams();
    const grouped = {};

    teams.forEach(team => {
      if (!grouped[team.sportTitle]) {
        grouped[team.sportTitle] = [];
      }
      grouped[team.sportTitle].push(team);
    });

    return grouped;
  }
}

export default FavoriteTeamService;